/** @typedef {import('../../types').ResponseHandler} ResponseHandler */
/** @typedef {import('../../types').FormValidationErrorResponse} FormValidationErrorResponse */
/** @typedef {import('../../../tnew/lib/FieldValidationProvider').default} FieldValidationProvider */


/**
 * @param {FieldValidationProvider} fieldValidationProvider
 */
const wrapper = fieldValidationProvider => ({

  /**
   * @type {ResponseHandler}
   * @param {FormValidationErrorResponse} response
   */
  handle: async ({ validationResult }) => {
    fieldValidationProvider.applyValidationResults(validationResult);
  },
});


export default wrapper;



// WEBPACK FOOTER //
// ./src/onePageGiving/hostedPayment/responseHandlers/FormValidationErrorResponseHandler.js